import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Autocomplete, TextField } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { GeoRehandleDTO } from "../../../DTOs/Geology/GeoRehandleDTO";

type MovementFromCellProps = {
  entry: GeoRehandleDTO,
  locationOptions: { value: number, label: string, isDumpOrCrusher: boolean }[],
  locationOptionsLoading: boolean,
  handleUpdateRow: (row: GeoRehandleDTO) => Promise<boolean | undefined>
  isReadOnly: boolean
}

const MovementFromCell: React.FC<MovementFromCellProps> = ({
  entry,
  locationOptions,
  locationOptionsLoading,
  handleUpdateRow,
  isReadOnly
}) => {
  const { t } = useTranslation("geology");
  const [isLoading, setLoading] = useState(false);

  return (
    <Autocomplete
      classes={{ root: 'w-full' }}
      size="small"
      loading={locationOptionsLoading}
      disabled={isReadOnly}
      options={locationOptions}
      value={locationOptions.find(x => x.value === entry.movementFromId) ?? null}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      getOptionLabel={(option) => option.label}
      onChange={async (_event, newValue) => {
        if (newValue) {
          setLoading(true);
          await handleUpdateRow(
            { ...entry, movementFromId: newValue.value }
          );
          setLoading(false);
        }
      }}
      renderOption={(props, option) => {
        const { key, ...rest } = props;
        return (
          <li key={key} {...rest}>
            <span className={`${option.isDumpOrCrusher === true ? "text-theme-danger" : ""}`}>{option.label}</span>
          </li>
        )
      }}
      renderInput={(params) => <TextField
        {...params}
        label={t("movement.movementFrom")}
        slotProps={{
          ...params.slotProps,
          input: {
            ...params.slotProps.input,
            className: `${locationOptions.find(x => x.value === entry.movementToId)?.isDumpOrCrusher === true ? "text-theme-danger" : ""}`,
            style: {
              transition: "color 0.2s ease-in-out"
            },
            endAdornment: (
              <>
                {(isLoading || locationOptionsLoading) && <FontAwesomeIcon icon={faSpinner} spin />}
                {params.slotProps.input.endAdornment}
              </>
            )
          }
        }}
      />}
    />);
};

export default MovementFromCell;